import Breadcrumb from 'models/Breadcrumb';
import CustomConfig from 'models/CustomConfig';
import MenuData from 'models/MenuData';
import Company from 'models/Profile/Company';
import CurrentCompany from 'models/Profile/CurrentCompany';
import { createContext } from 'react';

export type MenuContextData = {
  menu : MenuData,
  companies: Array<Company>,
  customConfig: CustomConfig,
  openedMenu: string,
  setCustomConfig : React.Dispatch<React.SetStateAction<CustomConfig>>,
  getBreadcrumb : () => Partial<Breadcrumb>,
  updateCurrentCompany : (company : CurrentCompany) => void,
  updateOpenedMenu : (productName : string) => void,
  isUndefined : () => boolean,
  fetchCompanies : () => Promise<void>,
  fetchMenu : () => Promise<void>
};

export const MenuContext = createContext({} as MenuContextData);